import React, { useState } from "react";
import { Formik, Form, useField } from "formik";
import * as Yup from "yup";
import styles from "./demandClosurePopup.module.css";
import { BackButton, Submit } from "../../../../components/button/buttons";
// import { TextArea } from "../../controllers/quotationControllers";
import {FormFieldLabel as Label, FormErrorLabel as ErrorLabel} from "../../../../components/label/Labels";
import IMAGES from "../../../../assets/images/images";
import { DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";
import { useParams } from "react-router-dom";
import Asterisk from "../../../../components/asterisk/Asterisk";
import { Tooltip } from "bootstrap";
import { FormTextArea } from "../../../../components/input/inputs";

const TextArea = ({ ...props }) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error ? true : false;
    const inputStyle = hasError
        ? `${styles.input} ${styles.inputError}`
        : styles.input;
    return (
        <div className={props.isExpandedField ? `${styles.Field} ${styles.expandedField}` : `${styles.Field}`}>
            {props.label &&<div>
                <Label
                    htmlFor={props.htmlFor}
                    text={props.label}
                    style={styles.lable}
                />
                {props.isMandatory ? <Asterisk /> : <></>}
            <div  className={styles.txtmsg}>Provide the reason for cancelling this demand.</div>
                {
                    props.showTooltip ?
                        <>
                            &nbsp;&nbsp;
                            <Tooltip text={props.tooltipText} />
                        </>
                        : <></>
                }
            </div>}
            {
                 !props.isPreviewMode?
                 <>
                   <FormTextArea
                    {...field} 
                    placeholder={props.placeholder} 
                    style={inputStyle} />
                    {props.textLimit ? <span className={styles.textLimitInfo}>{props.textLimit}</span> : null}
                    {hasError ? <ErrorLabel text={meta.error} /> : null}
                 </>:
                <div className={styles.previewText}>
                   {field?.value?field?.value.split('\n').map(text => <div>{text}</div>):"---"}
                </div>
            }
          
        </div>
    );
};

export default function DemandClosurePopup({ onClose, openAlertPopup,addDemandAction,getServiceDetail,setDemandClosure }) {
    const [isSubmit, setIsSubmit] = useState(false);
    console.log("isSubmit",isSubmit);
    
    let { requestId } = useParams();
    const MAX = 500;
    const schema = Yup.object({
        reason: Yup.string()
            .trim()
            .required("Comments are required")
            .max(MAX, `Maximum ${MAX} characters allowed`),
    });
    return (
        <div className={styles.backdrop} role="dialog" aria-modal="true">
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.title}>Cancel Demand</div>
                    {/* <img className={styles.crosicon} src={IMAGES.close} onClick={onClose} alt="Information icon" /> */}
                </div>
                <Formik
                    initialValues={{ reason: "" }}
                    validationSchema={schema}
                    validateOnMount
                    onSubmit={(vals) => {
                        setIsSubmit(true);
                        const payload = { action: DEMAND_ACTIONS.CLOSE_DEMAND, stateData: { reason: vals.reason } }
                        addDemandAction(payload, requestId).then((result) => {
                            if (result) {
                                openAlertPopup({
                                    message: "Demand cancelled successfully!",
                                    image: IMAGES.success
                                });
                                setDemandClosure(false);
                                setIsSubmit(false);
                                getServiceDetail(requestId);
                            } else {
                                openAlertPopup({
                                    message: "An error occurred while processing your request. Please try again later.",
                                    image: IMAGES.error
                                });
                                 setIsSubmit(false);
                            }
                        })
                            .catch((error) => {
                                openAlertPopup({
                                    message: "An error occurred while processing your request. Please try again later.",
                                    image: IMAGES.error
                                });
                                setIsSubmit(false);
                            });

                    }}
                >
                    {({ values, isSubmitting, isValid }) => (
                        <Form className={styles.body}>
                            <div className={styles.field}>
                                <TextArea
                                    name="reason"
                                    label={"Comment"}
                                    isMandatory={true}
                                    isPreviewMode={false}
                                    placeholder={"Enter your comments here..."}
                                    textLimit={`${values.reason?.length}/${MAX} characters`}
                                    rows={6}
                                    maxLength={MAX}
                                    count={values.reason?.length}
                                />
                                <div className={styles.helperRow}>
                                    <div className={styles.helperText}>
                                        <div>
                                            <div className={styles.textbold}>You are about to cancel this demand.</div>
                                            {/* <br/> */}
                                            Cancelling this demand will permanently <b>stop</b> all further processing, actions and updates associated with it.
                                            <br/>
                                           <div className={styles.textbold}> This action cannot be undone.</div>
                                        </div>
                                        <div>
                                           <div className={styles.textbold}> Do you want to proceed?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`${styles.footerwrapper}`}>
                                <div className={styles.footer}>
                                    <BackButton
                                        type="button"
                                        className={styles.backButton}
                                        closePopup={onClose}
                                        disabled = {isSubmit}
                                        title={"Cancel"}
                                    />
                                    <Submit
                                        type={"submit"}
                                        style={`${styles.submit}`}
                                        title={"Confirm"}
                                        isSubmitting={isSubmit}
                                        disabled={isSubmit || !isValid}
                                    />
                                </div>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}